// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SlideOut{position:absolute;top:10px;left:10px;z-index:9999}.BottomStatus{position:absolute;bottom:10px;left:10px;z-index:9999}`, "",{"version":3,"sources":["webpack://./src/scss/MapPage.scss"],"names":[],"mappings":"AAAA,UACE,iBAAA,CACA,QAAA,CACA,SAAA,CACA,YAAA,CAGF,cACE,iBAAA,CACA,WAAA,CACA,SAAA,CACA,YAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
